import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import useFormData from '@gef-ui/form-core/hooks/state/useFormData';
import useFormFieldValue from '@gef-ui/form-core/hooks/state/useFormFieldValue';
import Checkbox from '@gef-ui/form-material/Checkbox';
import { validationDisplayTypes } from '@gef-ui/form-material/constants';
import { getLabelMessage } from '@gef-ui/localization/messages';

import DatePickerFullWidth from 'components/atoms/GefMui/DatePickerFullWidth';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { campaignTypes } from 'constants/campaigns';
import { FIELDS } from 'features/views/campaignSettings/campaignDetail/form';

export const MaterialsOrder = ({ campaignType }) => {
	const formData = useFormData();
	const addMatOrder = useFormFieldValue({ fieldName: FIELDS.addMatOrder });
	const letterPrintedDate = useFormFieldValue({ fieldName: FIELDS.letterPrintedDate });

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Stack spacing={2}>
				<SectionHeader text={getLabelMessage('campaign:materialsOrderTitle')} />
				<Grid container>
					<Grid size={12}>
						<Grid container spacing={2}>
							<Grid size={4}>
								<Checkbox
									sx={{ ml: 0.5 }}
									fieldName={FIELDS.letterPrintedDate}
									label={getLabelMessage('campaign:letterPrintedDate')}
								/>
							</Grid>
							<Grid size={4}>
								{campaignType === campaignTypes.X_SELL && letterPrintedDate && (
									<DatePickerFullWidth
										fieldName={FIELDS.openLetterDate}
										label={getLabelMessage('campaign:openLetterDate')}
										required={letterPrintedDate}
										validationDisplay={
											!formData?.openLetterDate ? validationDisplayTypes.HIDDEN : undefined
										}
									/>
								)}
							</Grid>
							<Grid size={4} />
							<Grid size={4}>
								<Checkbox
									sx={{ ml: 0.5 }}
									fieldName={FIELDS.addMatOrder}
									label={getLabelMessage('campaign:addMatOrder')}
								/>
							</Grid>
							<Grid size={4}>
								<DatePickerFullWidth
									fieldName={FIELDS.orderStartDate}
									label={getLabelMessage('campaign:orderStartDate')}
									disabled={!addMatOrder}
									required={addMatOrder}
									validationDisplay={
										!formData?.orderStartDate ? validationDisplayTypes.HIDDEN : undefined
									}
								/>
							</Grid>
							<Grid size={4}>
								<DatePickerFullWidth
									fieldName={FIELDS.orderEndDate}
									label={getLabelMessage('campaign:orderEndDate')}
									disabled={!addMatOrder}
									required={addMatOrder}
									validationDisplay={
										!formData?.orderEndDate ? validationDisplayTypes.HIDDEN : undefined
									}
								/>
							</Grid>
							<Grid size={4}>
								<Checkbox
									sx={{ ml: 0.5 }}
									fieldName={FIELDS.nominationDate}
									label={getLabelMessage('campaign:nominationDate')}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Stack>
		</Paper>
	);
};

MaterialsOrder.propTypes = {
	campaignType: PropTypes.number,
};

export default MaterialsOrder;
